import React from "react";
import { useSelector } from "react-redux";
import { currentSelectedLanguage } from "../../../../../StateManagement/actions";

export function ContactGroupsList({ contactGroups = [], onEdit, onDelete, onAddNew, isReadOnlyScope = false, selectedIds = new Set(), onToggleSelect, onSelectAll, isAllSelected = false }) {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const loggedInUser = (localStorage.getItem("UserName") || localStorage.getItem("userEmail") || "").toLowerCase().trim();
  const userRole = localStorage.getItem("UserRole") || "";
  const isAdmin = userRole === "RDocsCompanyAdmin" || userRole === "RDocsSupportAdmin" || userRole === "Admin";

  if (!contactGroups || contactGroups.length === 0) {
    return (
      <div className="contacts-empty-container">
        <div className="contacts-empty-icon">
          <span className="material-icons font-32">groups</span>
        </div>
        <h4 className="contacts-empty-title">
          {selectedLanguage?.LstLanguageCodes?.UI_NoGroupsFound}
        </h4>
        <p className="contacts-empty-text">
          {selectedLanguage?.LstLanguageCodes?.UI_CreateNewGroupToOrganizeYourContacts}
        </p>
      </div>
    );
  }

  return (
    <div className="contacts-table-scroll">
      <table className="contacts-table">
        <thead>
          <tr>
            <th className="text-center cursor-pointer" style={{ width: "44px", minWidth: "44px", padding: "0" }} onClick={onSelectAll}>
              <div className="checkbox mt-0 mb-0 d-inline-flex align-items-center justify-content-center">
                <label className="ps-0 mb-0 cursor-pointer" onClick={(e) => e.stopPropagation()}>
                  <input type="checkbox" checked={isAllSelected && contactGroups.length > 0} onChange={onSelectAll} />
                  <span className={`cr ${isAllSelected && contactGroups.length > 0 ? "checked" : ""}`}>
                    <svg className="cr-icon-svg" viewBox="0 0 24 24" width="11" height="11" stroke="#ffffff" strokeWidth="3.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <i className="cr-icon material-icons">check</i>
                  </span>
                </label>
              </div>
            </th>
            <th>{selectedLanguage?.LstLanguageCodes?.UI_GroupName}</th>
            <th>{selectedLanguage?.LstLanguageCodes?.UI_DLEmail}</th>
            <th>{selectedLanguage?.LstLanguageCodes?.UI_AllowedDomains}</th>
            <th>{selectedLanguage?.LstLanguageCodes?.UI_GroupMembers}</th>
            <th>{selectedLanguage?.LstLanguageCodes?.UI_CreatedBy}</th>
            <th className="contacts-table-actions-header">
              {selectedLanguage?.LstLanguageCodes?.UI_Actions}
            </th>
          </tr>
        </thead>
        <tbody>
          {contactGroups.map((group) => {
            const groupId = group.id || group.name;
            const isSelected = selectedIds.has(groupId);
            const memberCount = group.memberContactIds ? group.memberContactIds.length : group.contactIds ? group.contactIds.length : 0;
            const domainCount = Array.isArray(group.domains) ? group.domains.length : 0;
            const createdByEmail = (group.createdBy || group.createdUser || "").toLowerCase().trim();
            const isCreator = Boolean(loggedInUser && createdByEmail && (loggedInUser === createdByEmail || createdByEmail.includes(loggedInUser)));
            const isReadOnly = (Boolean(group.isReadOnly) || isReadOnlyScope) && !isCreator && !isAdmin;

            return (
              <tr key={groupId} className={isReadOnly ? "contacts-row-readonly" : `cursor-pointer ${isSelected ? "contacts-row-selected" : ""}`} onClick={() => !isReadOnly && onToggleSelect && onToggleSelect(groupId)}>
                {/* Checkbox (Disabled for Read-Only Groups) */}
                <td className="text-center" style={{ width: "44px", minWidth: "44px", padding: "0" }} onClick={(e) => e.stopPropagation()}>
                  <div className="checkbox mt-0 mb-0 d-inline-flex align-items-center justify-content-center">
                    <label className={`ps-0 mb-0 ${isReadOnly ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}>
                      <input type="checkbox" disabled={isReadOnly} checked={!isReadOnly && isSelected} onChange={() => !isReadOnly && onToggleSelect && onToggleSelect(groupId)} />
                      <span className={`cr ${!isReadOnly && isSelected ? "checked" : ""} ${isReadOnly ? "contacts-cr-disabled" : ""}`}>
                        <svg className="cr-icon-svg" viewBox="0 0 24 24" width="11" height="11" stroke="#ffffff" strokeWidth="3.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <i className="cr-icon material-icons">check</i>
                      </span>
                    </label>
                  </div>
                </td>

                {/* Group Name */}
                <td title={group.name || ""}>
                  <div className="text-truncate font-13 text-dark" title={group.name || ""}>
                    {group.name}
                  </div>
                </td>

                {/* DL Email / Alias Email */}
                <td title={group.aliasEmail || ""}>
                  <div className="text-truncate font-13" title={group.aliasEmail || ""}>
                    {group.aliasEmail}
                  </div>
                </td>

                {/* Allowed Domains */}
                <td>
                  <span className="text-dark font-13 d-block" style={{textAlign:"center"}}>{domainCount}</span>
                </td>

                {/* Group Members */}
                <td>
                  <div className="flex-wrap gap-1 align-items-center" style={{textAlign:"center"}}>
                    <span className="font-13 gap-1">
                     {memberCount}
                    </span>
                    {group.isDistributionList && (<span className="badge bg-danger text-white font-11 px-2 py-1">Dist.List</span>)}
                  </div>
                </td>

                {/* Created By */}
                <td title={group.createdBy || ""}>
                  <div className="text-truncate font-13" style={{width:"125%"}} title={group.createdBy || ""}>
                    {group.createdBy}
                  </div>
                </td>

                {/* Actions */}
                <td className="contacts-table-actions-cell" onClick={(e) => e.stopPropagation()}>
                  {isReadOnly ? (
                    <span className="badge bg-light text-muted border font-11 px-2 py-1">
                      Read-Only
                    </span>
                  ) : (
                    <div className="d-inline-flex align-items-center">
                      <span className="material-icons contacts-action-icon edit-icon me-3" title={selectedLanguage?.LstLanguageCodes?.UI_Edit || "Edit"} onClick={() => onEdit(group)}>
                        edit
                      </span>
                      <span className="material-icons contacts-action-icon delete-icon" title={selectedLanguage?.LstLanguageCodes?.UI_Delete || "Delete"} onClick={() => onDelete(group)}>
                        delete
                      </span>
                    </div>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ContactGroupsList;